import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  Funnel,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useGetCurrentFunnel } from "@overrides/utilities";
import { PageLoadingScreen } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HotelListLoading.module.scss";
import { useBonusEarnResource } from "@/modules/wallet/BonusEarnBanner/useBonusEarnResource";

export interface HotelListLoadingComponentProps extends PlatformComponentProps {
  isLoading?: boolean;
}

export const HotelListLoading = ({
  isLoading,
  className,
  children,
}: HotelListLoadingComponentProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelListLoading,
    defaultStyles
  );
  const [block] = useModuleBEM(styles, CoreHotelsComponent.HotelListLoading);

  const { t } = useI18nContext();

  const funnel = useGetCurrentFunnel();
  const bonusResource = useBonusEarnResource();
  const isCampaignActive = Boolean(bonusResource) && funnel === Funnel.Lodging;

  return (
    <PageLoadingScreen
      isLoading={isLoading}
      className={clsx(block, className)}
      text={
        isCampaignActive
          ? t("hotelSearchLoaderCampaign.title")
          : t("core-hotels.availabilityPage.loadingScreen.title")
      }
      subtitle={
        isCampaignActive
          ? t("hotelSearchLoaderCampaign.subtitle")
          : t("core-hotels.availabilityPage.loadingScreen.subtitle")
      }
    >
      {children}
    </PageLoadingScreen>
  );
};
